"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const AlarmOn_1 = __importDefault(require("@mui/icons-material/AlarmOn"));
const Create_1 = __importDefault(require("@mui/icons-material/Create"));
const AccountBalance_1 = __importDefault(require("@mui/icons-material/AccountBalance"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const utils_1 = require("data/transactions/utils");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const MatchField = ({ attributes, SHOW_ALL, txn, }) => {
    const { classes } = useStyles();
    const renderMatchState = () => {
        let txnState = (0, utils_1.getTxnStateInfo)(txn).entry;
        if (txnState === 'scheduled') {
            txnState = 'blank';
        }
        switch (txnState) {
            case 'bank':
                return (<QTip_1.default title="Bank downloaded transaction" wrapId={`${txn.id}-match`}>
            <AccountBalance_1.default className={(0, classnames_1.default)(classes.matchStateIcon, txnState)}/>
          </QTip_1.default>);
            case 'manual':
                return (<QTip_1.default title="Manually entered transaction" wrapId={`${txn.id}-match`}>
            <Create_1.default className={(0, classnames_1.default)(classes.matchStateIcon, txnState)}/>
          </QTip_1.default>);
            case 'matched':
                return (<QTip_1.default title="Matched transaction" wrapId={`${txn.id}-match`}>
            <AccountBalance_1.default className={(0, classnames_1.default)(classes.matchStateIcon, txnState)}/>
          </QTip_1.default>);
            case 'scheduled':
                return (<QTip_1.default title="Scheduled transaction" wrapId={`${txn.id}-match`}>
            <AlarmOn_1.default className={(0, classnames_1.default)(classes.matchStateIcon, txnState)}/>
          </QTip_1.default>);
            default:
                return '';
        }
    };
    return (<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={(0, classnames_1.default)(classes.iconColumn, 'nopoint')}>
      {SHOW_ALL && renderMatchState()}
    </styles_1.RegListItem>);
};
exports.default = MatchField;
